export const levelsOptions = [
  {
    label: "Postgraduate",
    options: [
      { value: "Doctoral/PhD", label: "Doctoral/PhD" },
      { value: "Master", label: "Master" },
    ],
  },
  {
    label: "Undergraduate",
    options: [
      { value: "Bachelor Degree", label: "Bachelor Degree" },
      { value: "Graduate Qualifications", label: "Graduate Qualifications" },
    ],
  },
  {
    label: "Tertiary - Short Cycle",
    options: [
      { value: "Associate Degree", label: "Associate Degree" },
      { value: "Diploma Level", label: "Diploma Level" },
    ],
  },
  {
    label: "Non-Tertiary",
    options: [
      { value: "Pre-Vocational", label: "Pre-Vocational" },
      { value: "Vocational Preparation", label: "Vocational Preparation" },
    ],
  },

  {
    label: "Miscellaneous",
    options: [
      { value: "Language Courses", label: "Language Courses" },
      { value: "Others", label: "Others" },
    ],
  },
  {
    label: "Preparatory Programs",
    options: [{ value: "Foundation Studies", label: "Foundation Studies" }],
  },
  {
    label: "Research-Based",
    options: [{ value: "Research Programs", label: "Research Programs" }],
  },
];

export const programTypeOptions = [
  { value: "Blended Study", label: "Blended Study" },
  { value: "Full time", label: "Full Time" },
  { value: "Online Study", label: "Online Study" },
];

export const modeOfStudyOptions = [
  { value: "Blended", label: "Blended" },
  { value: "On Campus", label: "On Campus" },
  { value: "Online", label: "Online" },
];
